import { gql } from '@apollo/client';

export const RESCHEDULE = gql`
    mutation reschedule($startDatetime: String!, $id: Int!) {
        reschedule(startDatetime: $startDatetime, id: $id) {
            id
        }
    }
`;
